import styled from 'styled-components';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { FlexBoxRow } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';

export const SliderWrapper = styled.div`
    overflow: visible;
    width: calc(100% + 20px);
    margin: 0 -10px;
    @media(max-width: 1279px) {
        margin: 0 -5px;
        width: calc(100% + 10px);
    }
    @media(max-width: 767px) {
        max-width: 370px;
        margin-bottom: 48px;
    }
`;

export const Container = styled(GridContainer)`
    padding-left: 0;
    padding-right: 0;
`;

export const FlexBoxRowSlider = styled(FlexBoxRow)`
    min-width: 100%
`;
